import { render, staticRenderFns } from "./JuryMember.vue?vue&type=template&id=6da51218&scoped=true&"
import script from "./JuryMember.vue?vue&type=script&lang=ts&"
export * from "./JuryMember.vue?vue&type=script&lang=ts&"
import style0 from "./JuryMember.vue?vue&type=style&index=0&id=6da51218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da51218",
  null
  
)

export default component.exports